import { render, staticRenderFns } from "./PlanCardClub.vue?vue&type=template&id=77afdecc&scoped=true"
import script from "./PlanCardClub.vue?vue&type=script&lang=js"
export * from "./PlanCardClub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77afdecc",
  null
  
)

export default component.exports